<template>
  <div class="layout">
    <div class="layout-container">
      <!-- 二级路由的出口 -->
      <router-view></router-view>
    </div>

    <div class="tab">
      <van-tabbar v-model="isActive" @change="handleChange">
        <van-tabbar-item name="home" icon="home-o" to="/">
          <div class="icon-container" v-show="pageName === 'home'"></div>
          <span>首页</span>
          <template #icon>
            <span class="iconfont iconshouye"></span>
          </template>
        </van-tabbar-item>

        <van-tabbar-item name="service" icon="search" to="/service">
          <div class="icon-container" v-show="pageName === 'service'"></div>
          <span>服务</span>
          <template #icon>
            <span class="iconfont iconfuwu"></span>
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="agency" icon="friends-o" to="/agency">
          <div class="icon-container" v-show="pageName === 'agency'"></div>
          <span>机构</span>
          <template #icon>
            <span class="iconfont iconjigou"></span>
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="user" icon="setting-o" to="/user">
          <div class="icon-container" v-show="pageName === 'user'"></div>
          <span>我的</span>
          <template #icon>
            <span class="iconfont iconwode"></span>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import wx from "weixin-js-sdk";
import { getDatas } from "@/api/user.js";
import { mapMutations } from "vuex";
import constants from "@/common/constants.js";
import { areaCode } from "@/common/constants.js";

import { getOpenIdAndUser } from "../../api/user";
export default {
  name: "Layout",
  components: {},
  data() {
    return {
      tabBar: true,
      appId: "",
      pageName: ""
    };
  },
  // watch: {
  //   $route: function(to, form) {
  //     // console.log(to,form);
  //     if (to.path === "/login") {
  //       this.tabBar = false;
  //     } else {
  //       this.tabBar = true;
  //     }
  //   }
  // },
  methods: {
    ...mapMutations("globel", ["toggleTab"]),
    ...mapMutations("user", ["setOpenId"]),
    handleChange() {
      constants.service = "养老服务";
    },
    getCode() {
      // 非静默授权，第一次有弹框
      this.code = "";
      var local = window.location.href; // 获取页面url
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
          this.appId
        }&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        // 你自己的业务逻辑
        getOpenIdAndUser({ code: this.code, areaCode: areaCode }).then(
          response => {
            if (response.openid) {
              console.log("openId", response.openid);
              window.localStorage.setItem("openId", response.openid);
              this.setOpenId(response.openid);
              window.localStorage.setItem("userInfo", JSON.stringify(response));
              this.setUserInfo(response);
            }
          }
        );
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      console.log(theRequest);
      return theRequest;
    },
    async getAppId() {
      const thisPageUrl = location.href.split("#")[0];
      const res = await getDatas({
        url: thisPageUrl,
        areaCode
      });
      this.appId = res.appId;
    }
  },
  computed: {
    isActive: {
      // getter
      get: function() {
        return this.$store.state.globel.isActive;
      },
      // setter
      set: function(newValue) {
        this.pageName = newValue;
        this.toggleTab(newValue);
      }
    }
  },
  async mounted() {
    // console.log(this.$route)
    // if (this.$route.path === "/login") {
    //   this.tabBar = false;
    // } else {
    //   this.tabBar = true;
    // }
    this.pageName = this.$route.name;
    this.toggleTab(this.$route.name);

    await this.getAppId();

    if (!window.localStorage.getItem("openId")) {
      console.log(1);
      // 如果缓存localStorage中没有微信openId，则需用code去后台获取
      // this.getCode();
      // this.$router.push("/login");
    } else {
      // 别的业务逻辑
    }
  }
};
</script>

<style lang="scss">
.layout-container {
  padding-bottom: 50px;
}
.tab {
  .icon-container {
    width: 26px;
    height: 32px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABACAYAAABVy1Q8AAAAAXNSR0IArs4c6QAAAvBJREFUaEPtWNtOE0EY/v7ZbktLhcRDagyiILVYEGJqUiu8hu/D+/gS3iBywYVoC6WgBCURjCRA6Wl3Z0y3iiCFzngYRjO9bOab/zvM/DOzJFZmc/iPfmQFGZ6mTcjwgGATsglpdsAuOc2GK5ezCSlbphlgE9JsuHI5m5CyZZoBNiHNhiuXswkpW6YZYBPSbLhyOZuQsmWaATYhzYYrl7MJKVumGWAT0my4cjmbkLJlmgE2Ic2GK5ezCSlbphlgE9JsuHI5EsXCIzCHKSNNBPCAkyjPToMjYiI/ZU4BfBKlp5MgFlMGmwgQvEmilE+D3AET+SlzEt4BieLMMBjdUAabCHDZLoly7jp4/I6J/NQ5tTZJVMZi8G9OqoMNRPC9N9SmJVYKDwEnaiBFeUrthpB9+bYj6HV+CFE3JY82cCQLPlFmYbsj6EMhjqqTNZCmPKVkUKLbC/VQUChqdSYDQUn5GQwaSaJK4/PlNqMfgjZyg2jFxwyiKU8lWl+ne0v7pwSFKa09eYAgkpCfyYCRjl+j+69WvjM5TqjTHKb64SYyoMip/w2g3Z2C8AW8Wpmml4+6CgpFFXPDYPF/4+bAxWeamN86qfZMEmIODM/y42Bu3Nhk2sS4V8fzxVWaA79QUJjS+7t9aA1ljH1WMPiIfizTyGbjZ9PP3SuimE0Cg2njHn8OD1CvVk7um54JHZ9NlfwAhDOKgDlGLL+2GE4bND5/eB6fnt0s7HzOwBicS37VBvDRqFfo8VLtInN7Cup0vmwUkcFRcKf/UpLygiM4++9ootTqVV9KUChKgLBWuIVApLSdU+E5I3YxtbhNBNFLzJmbggwgvMgeseG/f+9rHaIvsUUjL850st9ect0mEO2G4SH1x79HCO8ALnYovXggY7B025adLHzxBqlr4OLqL389ErwJRntwdr5Qer0pW7vbOOk9JFMkbB4seQWuSKDF+gAnBu47YN/aPucBWCQAgiaisQa8Rg28eiiz2WXqt8d8BWAlLc/y/nx1AAAAAElFTkSuQmCC");
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    position: absolute;
    top: 0;
  }
  .van-tabbar {
    .van-tabbar-item__icon {
      margin: 0 0 7px 0;
    }
    .van-tabbar-item.van-tabbar-item--active {
      color: #543302;
    }
    .van-tabbar-item {
      color: #7a7a7a;
      font-weight: 700;
    }
  }
}
</style>
